import { render, staticRenderFns } from "./AdresItem.vue?vue&type=template&id=c477f5d4&scoped=true"
import script from "./AdresItem.vue?vue&type=script&lang=js"
export * from "./AdresItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c477f5d4",
  null
  
)

export default component.exports